import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Pagination from "react-js-pagination";
import {apiService} from '../../common/apiCallService';
import Loading from '../Loading.js';
import {baseUrl} from '../../common/config.js';
import Menu from '../Menu.js'
import { Redirect } from 'react-router';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import validator from 'validator';

class NewModulesNlessons extends Component {

  constructor(props) {
    super(props)
    this.state = {
      id:props.data ? props.data._id : '',
      open:false,
      type:props.data && Object.keys(props.data).length >0 ? props.data.type : 'Course/Module/Lesson',
      order:props.data ? props.data.order : '',
      type_name:props.data ? props.data.contentName : '',
      loginRedirect: false,
      openerrDialog:false,
      loading: true,
      type_name_error:'',
      order_error:'',
      course_name:'',
      course_name_error:'',
      courseOrder:0,
      selectedModuleId:props.data ? props.data._id : '',
      selectedModuleId_error:'',
      course_error:'',
      _id:props.data ? props.data._id : '',
      modules:[],
      courses:[],
      openCourseDialog:false,
      textContent:props.data ? props.data.courseIntro : '',
    }
    this.getCourse()
  }

  getCourse = () => {
    this.setState({loading: true})
    apiService(baseUrl + '/clinic/getCourse', {
      "type": 'Course',
    }, (data) => {
      this.setState({
        courses: data,
        loading: false
      })
      if(this.props.data){
        if(this.props.data.type == 'Module' && this.props.data.parentId)
          this.setState({_id: this.props.data.parentId})
        if(this.props.data.type == 'Lesson' && this.props.data.parentId){
          this.setState({selectedModuleId: this.props.data.parentId})
          apiService(baseUrl + '/clinic/getModuleOrLessonDtls', {
              "_id": this.props.data.parentId
          }, (data) => {
            this.state.modules.push(data)
            this.setState({loading: false})
              this.setState({_id: data.parentId})

          }, (data) => {
            this.setState({loading: false})
            if(data.status == 403) {
              localStorage.setItem("pathName", this.props.pathname)
              this.setState({loginRedirect: true})
            }
          })
        }
      }


    }, (data) => {
      this.setState({loading: false})
      if(data.status == 403) {
        localStorage.setItem("pathName", this.props.pathname)
        this.setState({loginRedirect: true})
      }
    })
  }

  getModules = () => {
    this.setState({loading: true})
    apiService(baseUrl + '/clinic/getModules', {
        "_id": this.state._id
    }, (data) => {
      this.setState({
        modules: data,
        loading: false
      })
    }, (data) => {
      this.setState({loading: false})
      if(data.status == 403) {
        localStorage.setItem("pathName", this.props.pathname)
        this.setState({loginRedirect: true})
      }
    })
  }

  setToDefault = () =>{
    this.setState({
      type:'',
      order:'',
      type_name:'',
      selectedModuleId:'',
      order_error:'',
      selectedModuleId_error:'',
      type_name_error:'',
      loginRedirect: false,
    })
  }

  handleClose = () => {
    this.setState({open: false})
    this.setToDefault()
    this.props.newModulesNlessonsDialog()
   }

  validate = () => {
    this.setState({
      type_error:'',
      type_name_error:'',
      selectedModuleId_error:'',
      order_error:''
    })
    // if(this.state.type == 'Course'){
    //   if(!this.state.type_name) return this.setState({type_name_error: 'Enter '+this.state.type+' Name'})
    //   if(this.props.data && Object.keys(this.props.data).length >0) this.updateModuleOrLesson()
    //   else this.saveCourseModuleNlesson()
    // }
    // else{
      if(validator.isEmpty(this.state.type)) return this.setState({type_error: 'Select Type'})
      if(validator.isEmpty(this.state.type_name)) return this.setState({type_name_error: 'Enter '+this.state.type+' Name'})
      if(this.state.type == 'Lesson')
        if(this.state.selectedModuleId == '')
         return this.setState({selectedModuleId_error: 'Select module'})
      if(this.state.order =='') return this.setState({order_error: 'Enter order'})
      if(!validator.isNumeric(this.state.order.toString())) return this.setState({order_error: 'Order should be number'})

      if(this.state.id) this.updateModuleOrLesson()
      else this.saveCourseModuleNlesson()
    // }
  }

  saveCourseModuleNlesson = () => {
    this.setState({loading: true})
    apiService(baseUrl + '/clinic/saveCourseModuleNlesson', {
      "contentName": this.state.type_name,
      "type": this.state.type,
      "order":this.state.order,
      "parentId": this.state.selectedModuleId ? this.state.selectedModuleId : this.state._id,
      "courseIntro":this.state.type == 'Course' ?  this.state.textContent : ''
    }, (data) => {
      this.setState({
        openModuleNLessonDialog:false,
        loading: false,
        msg: data.msg,
        open: true,
      })
    }, (data) => {
        this.setState({loading: false})
        if(data.status == 406) {
          this.setState({
           msg: data.responseJSON.msg,
           openerrDialog: true
          })
        }
        if(data.status == 403) {
          localStorage.setItem("pathName", this.props.pathname)
          this.setState({loginRedirect: true})
        }
   })
  }

  updateModuleOrLesson = () => {
    var parentId =''
    this.setState({loading: true})
    if(this.state.type == 'Module')
       parentId =this.state._id
    else if(this.state.type == 'Lesson')
       parentId =this.state.selectedModuleId

    apiService(baseUrl + '/clinic/updateModuleOrLesson', {
      "contentName": this.state.type_name,
      "type": this.state.type,
      "order":this.state.order,
      "_id":this.state.type == 'Course' ? this.state._id : this.state.id,
      "parentId": parentId,
      "courseIntro": this.state.textContent
    }, (data) => {
      this.setState({
        openModuleNLessonDialog:false,
        loading: false,
        msg: data.msg,
        open: true,
      })
    }, (data) => {
        this.setState({loading: false})
        if(data.status == 406) {
          this.setState({
           msg: data.responseJSON.msg,
           openerrDialog: true
          })
        }
        if(data.status == 403) {
          localStorage.setItem("pathName", this.props.pathname)
          this.setState({loginRedirect: true})
        }
   })
  }

  onTypeChange = (event,index,value) => {
    this.setState({type: value})
  }

  onCourseChange = (event,index,value) => {
    this.state._id = value
    this.forceUpdate()
    this.getModules()
  }

  closeModuleNLessonDialog = () => {
    this.setState({openModuleNLessonDialog: false})
    this.setToDefault()
  }

  closeerrDialog = () => {
    this.setState({
      openerrDialog: false,
    })
    this.setToDefault()
  }

  onContentChange = (event,value) => {
    this.setState({textContent: event.target.value})
  }

  render() {
    const actions = [
        <FlatButton
          label="CANCEL"
          primary={true}
          onClick={this.closeCourseDialog}
        />,
        <FlatButton
          label="SUBMIT"
          data-e2e="SUBMIT"
          primary={true}
          onClick={() => this.validate()}
        />,
    ];
    return (
      <div>
          {this.state.loading
            ? <Loading/>
            : null}
          {this.state.loginRedirect && (<Redirect to={'/'}/> )}
          <div>
           <Dialog
              actions={<FlatButton label="Ok" data-e2e="OK" primary={true} keyboardFocused={true} onClick={this.handleClose}/>}
              modal={false}
              open={this.state.open}
              onRequestClose={this.handleClose}
            >
             {this.state.msg}
          </Dialog>
          <Dialog
            actions={<FlatButton label="Ok" data-e2e="OK" primary={true} keyboardFocused={true} onClick={this.closeerrDialog}/>}
            modal={false}
            open={this.state.openerrDialog}
            onRequestClose={this.closeerrDialog}
          >
           {this.state.msg}
          </Dialog>
         </div>
          <div>
             <center>
               <SelectField
                 floatingLabelText="Select Type"
                 value={this.state.type}
                 style={{textAlign: 'left'}}
                 onChange = {(event, index, value) =>  this.onTypeChange(event, index, value)}
                 errorText={this.state.type_error}
                 data-e2e={this.state.type}
                 >
                 <MenuItem value='Course' primaryText='Course' data-e2e="Course"/>
                 <MenuItem value='Module' primaryText='Module' data-e2e="Module"/>
                 <MenuItem value='Lesson' primaryText='Lesson' data-e2e="Lesson"/>
               </SelectField><br/>
               {this.state.type == 'Module' || this.state.type == 'Lesson'
                 ?<span><SelectField
                   floatingLabelText="Select Course"
                   data-e2e="select course"
                   value={this.state._id}
                   style={{textAlign: 'left'}}
                   onChange = {(event, index, value) =>  this.onCourseChange(event, index, value)}
                   errorText={this.state.type_error}
                   >
                   <MenuItem value='Select' primaryText="Select" disabled/>
                   {this.state.courses.map((obj, index) => {
                     return <MenuItem  key={obj._id} value={obj._id} primaryText={obj.contentName} data-e2e={obj.contentName} />
                   })}
                 </SelectField><br/></span>
                 :null
               }
               {
                 this.state.type == 'Lesson'
                 ?<SelectField
                    floatingLabelText="Modules"
                    style={{textAlign: 'left'}}
                    value={this.state.selectedModuleId}
                    onChange = {(event, index, value) =>  this.setState({selectedModuleId:value})}
                    errorText={this.state.selectedModuleId_error}
                  >
                    <MenuItem value='Select' primaryText="Select" disabled/>
                    {this.state.modules.map((obj, index) => {
                      return <MenuItem  key={obj._id} value={obj._id} primaryText={obj.contentName}/>
                    })}
                </SelectField>
                 :null
               }
               <br/>
               <TextField
                hintText={"Enter "+this.state.type+" Name"}
                floatingLabelText={this.state.type+" Name"} data-e2e="modulename"
                value = {this.state.type_name}
                errorText = {this.state.type_name_error}
                onChange = {(event,newValue) => this.setState({type_name: newValue})}
                /> <br/>
               <TextField
                     hintText='Enter Order'
                     floatingLabelText='Order' data-e2e="module_order"
                     value = {this.state.order}
                     errorText = {this.state.order_error}
                     onChange = {(event,newValue) => this.setState({order: newValue})}
                     />
            {this.state.type == 'Course'
              ? <div>
                <textarea placeholder="Enter Content" style={{ width: '45%', backgroundColor: '#303030', border: 'none', color: 'white', padding: '16px', marginTop: '20px' }} value={this.state.textContent} ref='textContent'
                  onChange={(event, newValue) => this.onContentChange(event, newValue)} />
              </div>
              : null}
             </center>
        </div>
     </div>
    )
  }

}

export default NewModulesNlessons



/** WEBPACK FOOTER **
 ** ./src/components/Course/NewModulesNlessons.js
 **/